<template>
    <div>
        <page-header :btnNew="this.$hasPermission('ReserveType_create') ? 'ACTIONS.NEW' : null" pageTitle="RESERVE_TYPES.INDEX_TITLE"
                     @newType="setRegisterModal"/>
        <list-component :items="items.data" :haveOptions="false" v-if="items && items.data">
            <template v-slot:principal-info="{items}">
                <div class="row gutters" style="align-items: center;">
                    <div class="col-xl-2 col-lg-3 col-md-3 col-sm-5 col-12 text-center">
                        <div class="task-name list-primary" :style="{color: items.iten.text_color}">{{
                                items.iten.name
                            }}
                        </div>
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-2 col-sm-7 col-12"
                         :style="widthPhone() ? 'margin-left: 5%' : ''"
                         v-if="this.$hasPermission('ReserveType_show')">
                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" :id="'active'+items.key"
                                   v-model="items.iten.has_limit_time"
                                   @click="updateTimeLimit(items.iten, items.key)"
                                   :disabled="!this.$hasPermission('ReserveType_update') || !canEdit(items.iten)">
                            <label class="custom-control-label" :for="'active'+items.key">{{
                                    t('RESERVE_TYPES.HAS_TIME_LIMIT')
                                }}</label>
                        </div>
                    </div>
                    <div class="col-xl-2 col-lg-2 col-md-3 col-sm-4 col-11" v-if="this.$hasPermission('ReserveType_show')"
                         :style="inputsStyle()">
                        <label for="front_size">{{ t('PROPERTIES.DESCRIPTION') }}: </label>
                        <input type="text" class="form-control" v-model="items.iten.name"
                               :disabled="!this.$hasPermission('ReserveType_update') || !canEdit(items.iten)"
                               @focus="setOriginalReserveType(items.iten.name)"
                               @change="updateReserveType(items.iten.name, items.iten, items.key,'PROPERTIES.DESCRIPTION')">
                    </div>
                    <div class="col-xl-2 col-lg-2 col-md-2 col-sm-4 col-11" v-if="this.$hasPermission('ReserveType_show')"
                         :style="inputsStyle()">
                        <label for="front_size">{{ t('SITUATIONS.TEXT_COLOR') }}: </label>
                        <div class="reserve-type-color-picker" @click.stop>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <button type="button" class="btn btn-outline-secondary reserve-type-color-preview"
                                            :style="{backgroundColor: normalizeHexColor(items.iten.text_color) || '#000000'}"
                                            :disabled="!this.$hasPermission('ReserveType_update') || !canEdit(items.iten)"
                                            @click="toggleReserveTypeColorPicker(items.key, items.iten)">
                                    </button>
                                </div>
                                <input type="text" class="form-control" maxlength="7" placeholder="#000000"
                                       :value="items.iten.text_color"
                                       :disabled="!this.$hasPermission('ReserveType_update') || !canEdit(items.iten)"
                                       @focus="setOriginalReserveType(items.iten.text_color)"
                                       @input="items.iten.text_color = $event.target.value"
                                       @keyup.enter="updateReserveTypeColor($event.target.value, items.iten, items.key,'SITUATIONS.TEXT_COLOR')"
                                       @change="updateReserveTypeColor($event.target.value, items.iten, items.key,'SITUATIONS.TEXT_COLOR')">
                            </div>
                            <div class="reserve-type-color-palette" v-if="openColorPickerKey === items.key">
                                <div class="reserve-type-color-palette-header">
                                    <span>Escolha uma cor</span>
                                    <button type="button" class="reserve-type-color-close"
                                            @click="openColorPickerKey = null">&times;</button>
                                </div>
                                <div class="reserve-type-color-group" v-for="group in colorOptions" :key="group.name">
                                    <span class="reserve-type-color-group-title">{{ group.name }}</span>
                                    <div class="reserve-type-color-grid">
                                        <button type="button" v-for="color in group.colors" :key="color"
                                                class="reserve-type-color-option"
                                                :class="{'active': normalizeHexColor(items.iten.text_color) === color}"
                                                :style="{backgroundColor: color}"
                                                :title="color"
                                                @click="selectReserveTypeColor(color, items.iten, items.key)">
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="this.$hasPermission('ReserveType_delete') && canEdit(items.iten)" id="deleteButton"
                         class="col-xl-2 col-lg-1 col-md-1 col-sm-2 col-11 text-right" :style="buttonStyle()">
                        <button class="btn btn-secondary" :title="t('ACTIONS.DELETE')"
                                @click="showAlert(items.iten.id)">
                            <i class="icon-delete"></i>
                        </button>
                    </div>
                </div>
            </template>
        </list-component>

        <div class="card" v-if="items && !items.data">
            <div class="card-header"></div>
            <div class="card-body pt-0">
                <div class="text-center">
                    <h5>{{ t('GENERAL.MSG.NO_REGISTER', {name: t('RESERVE_TYPES.INDEX_TITLE'), os: 'as'}) }}</h5>
                </div>
            </div>
        </div>
        <pagination-component v-if="items && items.data" :items="items" :to="'/tipo-reserva'"
                              @changePage="index($event)"></pagination-component>
        <modal :titleModal="modalTitle">
            <template v-slot:title>{{ t(modalTitle) }}</template>
            <create-reserve-types v-if="reserveType" :reserveTypeIndex="reserveType" :showLimitTime="showLimitTime"
                                  @created="updateAfterCreated"></create-reserve-types>
        </modal>
    </div>
</template>

<script>

import {useI18n} from "vue-i18n";
import Modal from "@/components/modal";
import {useToast} from "vue-toastification";
import Validate from '@/components/validate.vue';
import ReserveTypes from '@/services/ReserveTypes';
import pageHeader from "@/components/layouts/pageHeader";
import createReserveTypes from "./createReserveTypesComponent";
import ListComponent from "@/components/layouts/listComponent.vue";
import PaginationComponent from "@/components/layouts/PaginationComponent";

export default {
    name: 'IndexReserveTypes',
    mixins: [Validate],
    components: {
        Modal,
        pageHeader,
        ListComponent,
        createReserveTypes,
        PaginationComponent,
    },
    setup() {
        const toast = useToast();
        const {t} = useI18n();
        return {t, toast}
    },
    data() {
        return {
            notHaveReserves: true,
            items: null,
            modalTitle: null,
            reserveTypes: [],
            reserveType: null,
            showLimitTime: null,
            originalReserveType: null,
            openColorPickerKey: null,
            colorOptions: [
                {name: 'Neutras', colors: ['#000000', '#212529', '#343a40', '#495057', '#6c757d', '#adb5bd', '#ced4da', '#ffffff']},
                {name: 'Quentes', colors: ['#7f1d1d', '#b91c1c', '#dc2626', '#ef4444', '#f97316', '#fb923c', '#eab308', '#facc15']},
                {name: 'Verdes', colors: ['#14532d', '#166534', '#15803d', '#16a34a', '#22c55e', '#4ade80', '#86efac', '#dcfce7']},
                {name: 'Azuis', colors: ['#164e63', '#0891b2', '#06b6d4', '#67e8f9', '#1e3a8a', '#2563eb', '#60a5fa', '#bfdbfe']},
                {name: 'Roxas', colors: ['#312e81', '#4338ca', '#6366f1', '#a5b4fc', '#581c87', '#9333ea', '#c084fc', '#f3e8ff']},
                {name: 'Rosas', colors: ['#831843', '#be185d', '#db2777', '#ec4899', '#f472b6', '#f9a8d4', '#9d174d', '#fce7f3']},
                {name: 'Terrosas', colors: ['#3f2a1d', '#5d4037', '#795548', '#8d6e63', '#a1887f', '#bcaaa4', '#d7ccc8', '#efebe9']}
            ],
        }
    },
    mounted() {
        this.$canAccess('ReserveType_index');
        this.$store.commit('changeLoading', true);
        this.notHaveReserves = true;
        this.index();
    },
    methods: {
        canEdit(iten){
          return iten.name !== 'Corretor'
        },
        async index(page = 1) {
            await ReserveTypes.index(page).then(resp => {
                this.items = resp.data;
                this.checkIfAreReserveNow(this.items);
                this.reserveTypes = resp.data.data;
            }).catch(error => {
                this.$store.commit('changeLoading', false);
                this.errorMsg(error)
            });
            this.showLimitTime = this.items.data && this.items.data.find(t => t.has_limit_time) ? false : true;
            this.$store.commit('changeLoading', false);
        },
        checkIfAreReserveNow() {
            ReserveTypes.haveReserveNow({type: 0}).then((res) => {
                if (!res.data.validations) {
                    this.notHaveReserves = false;
                }
            });
        },
        setRegisterModal() {
            this.modalTitle = 'RESERVE_TYPES.MODAL_TITLE.ADD';
            this.reserveType = {
                name: null,
                text_color: '#000000',
                has_limit_time: false
            }
        },
        showAlert(reserve_id) {
            this.$swal.fire({
                title: this.t('GENERAL.MSG.REALLY_WANT_DELETE'),
                showCancelButton: true,
                showCloseButton: true,
                confirmButtonText: `Excluir`,
                cancelButtonText: 'Cancelar'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$store.commit('changeLoading', true);
                    ReserveTypes.delete(reserve_id).then(resp => {
                        document.getElementById('closeX').click();
                        this.index();
                        this.$store.commit('changeLoading', false);
                        this.toast.success(resp.data.validations.message);
                    }).catch(error => {
                        this.$store.commit('changeLoading', false);
                        this.errorMsg(error)
                    });
                }
            });
        },
        updateAfterCreated() {
            this.index();
        },
        updatePaginate(page) {
            this.updateItemsFromPaginate(page, ReserveTypes)
        },
        setOriginalReserveType(reserveType) {
            this.originalReserveType = reserveType;
        },
        normalizeHexColor(color) {
            if (!color) {
                return null;
            }

            const hexColor = color.trim().startsWith('#') ? color.trim() : `#${color.trim()}`;

            return /^#[0-9A-Fa-f]{6}$/.test(hexColor) ? hexColor.toLowerCase() : null;
        },
        toggleReserveTypeColorPicker(key, reserveType) {
            this.setOriginalReserveType(reserveType.text_color);
            this.openColorPickerKey = this.openColorPickerKey === key ? null : key;
        },
        selectReserveTypeColor(color, reserveType, key) {
            this.openColorPickerKey = null;
            this.updateReserveTypeColor(color, reserveType, key, 'SITUATIONS.TEXT_COLOR');
        },
        updateReserveTypeColor(color, reserveType, key, msg) {
            const hexColor = this.normalizeHexColor(color);

            if (!hexColor) {
                reserveType.text_color = this.originalReserveType || '#000000';
                this.toast.error('Informe uma cor hexadecimal válida. Ex: #000000');
                return;
            }

            this.updateReserveType(hexColor, reserveType, key, msg, 'text_color');
        },
        updateReserveType(target, reserveType, key, msg, field = null) {
            const updatedReserveType = {...reserveType};

            if (field) {
                updatedReserveType[field] = target;
                reserveType[field] = target;
            }

            if (target != this.originalReserveType) {
                ReserveTypes.update(updatedReserveType).then(resp => {
                    this.items.data[key] = field ? {...resp.data, [field]: target} : resp.data;
                    this.originalReserveType = target;
                    this.toast.success(this.t('GENERAL.MSG.PLACEHOLDER_UPDATE_SUCCESS', {name: this.t(msg)}));
                }).catch(error => {
                    this.errorMsg(error);
                });
            }
        },
        updateTimeLimit(reserveType, key) {
            reserveType.has_limit_time = !reserveType.has_limit_time;
            ReserveTypes.update(reserveType).then(resp => {
                this.items.data[key] = resp.data;
                this.toast.success(this.t('GENERAL.MSG.PLACEHOLDER_UPDATE_SUCCESS', {name: this.t('RESERVE_TYPES.HAS_TIME_LIMIT')}));
            }).catch(error => {
                this.errorMsg(error);
            });
        },
        haveLimitTime(reserveType) {
            let reseveWithLimiteTime = this.items.data.find(t => t.has_limit_time)
            if (reseveWithLimiteTime) {
                if (reseveWithLimiteTime.id == reserveType.id) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        inputsStyle() {
            if (window.innerWidth < 768) {
                return 'margin-left: 5%; margin-top: 2%; margin-bottom: 2%'
            }
        },
        buttonStyle() {
            if (window.innerWidth < 768) {
                return 'margin-top: 4%; margin-right: 2%';
            } else {
                return 'margin-top: 2%; margin-bottom: 1%';
            }
        }
    }
}
</script>

<style>
.padding {
    padding: 3rem;
}

.border-top2 {
    border-top: 1px solid #e6ebf1;
}

.custom-control-input:disabled ~ .custom-control-label::before {
    top: 2px;
}

.custom-switch .custom-control-label::before {
    top: 2px;
}

.reserve-type-color-picker {
    position: relative;
}

.reserve-type-color-preview {
    width: 44px;
    min-width: 44px;
    border-color: #ced4da;
    box-shadow: inset 0 0 0 2px #ffffff;
}

.reserve-type-color-preview:disabled {
    opacity: 0.65;
}

.reserve-type-color-palette {
    position: absolute;
    top: 42px;
    left: 0;
    z-index: 30;
    width: 332px;
    padding: 12px;
    background: #ffffff;
    border: 1px solid #ced4da;
    border-radius: 8px;
    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.16);
}

.reserve-type-color-palette-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
    color: #343a40;
    font-size: 0.82rem;
    font-weight: 600;
}

.reserve-type-color-close {
    padding: 0;
    width: 24px;
    height: 24px;
    color: #6c757d;
    background: transparent;
    border: 0;
    border-radius: 50%;
    font-size: 1.15rem;
    line-height: 1;
    cursor: pointer;
}

.reserve-type-color-close:hover {
    color: #343a40;
    background: #f1f3f5;
}

.reserve-type-color-group + .reserve-type-color-group {
    margin-top: 8px;
}

.reserve-type-color-group-title {
    display: block;
    margin-bottom: 4px;
    color: #6c757d;
    font-size: 0.68rem;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
}

.reserve-type-color-grid {
    display: grid;
    grid-template-columns: repeat(8, 28px);
    gap: 8px;
}

.reserve-type-color-option {
    width: 28px;
    height: 28px;
    padding: 0;
    border: 1px solid #ced4da;
    border-radius: 50%;
    box-shadow: inset 0 0 0 2px rgba(255, 255, 255, 0.65);
    cursor: pointer;
    transition: transform 0.12s ease, box-shadow 0.12s ease;
}

.reserve-type-color-option:hover {
    transform: scale(1.12);
    box-shadow: inset 0 0 0 2px rgba(255, 255, 255, 0.75), 0 2px 8px rgba(0, 0, 0, 0.18);
}

.reserve-type-color-option.active {
    outline: 2px solid #212529;
    outline-offset: 2px;
}

@media (max-width: 575.98px) {
    .reserve-type-color-palette {
        width: 292px;
    }

    .reserve-type-color-grid {
        grid-template-columns: repeat(8, 23px);
        gap: 7px;
    }

    .reserve-type-color-option {
        width: 23px;
        height: 23px;
    }
}
</style>
